import React from 'react';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="position-absolute Not-Found">
            <h2 className="text-center mt-5">404 Page not found 😟😟</h2>
        </div>
    );
};

export default NotFound;
